<template>
  <div id="main">
    <split-pane :default-percent='20' :min-percent='10' split="vertical">
      <template slot="paneL">
        <div id="treeDivs">
          <ResourcesTree ref="resourcesTree" :parentMsg="resourcesTreeMsg" v-on:treeInfo="getTreeInfo"></ResourcesTree>
        </div>
      </template>
      <template slot="paneR">
        <div id="listTables">
          <div class="rightTopButton">
            <el-button
              plain
              size="small"
              type="primary"
              @click="formAdd()">新增
            </el-button>
          </div>
          <div class="rightContent">
            <el-table
              row-key="resourceId"
              ref="singleTable"
              :data="tableData"
              :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
              :highlight-current-row="true"
              border
              height="100%"
              size="small"
              stripe
              style="width: 100%">
              <el-table-column label="名称" property="resourceName" width="200"></el-table-column>
              <el-table-column label="地址" property="url"></el-table-column>
              <el-table-column align="center" label="排序号" property="orderNo" width="120"></el-table-column>
              <el-table-column align="center" label="类型" property="type" width="80"></el-table-column>
              <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button
                    circle
                    icon="el-icon-s-promotion"
                    plain
                    size="mini"
                    title="移动"
                    @click="move(scope.$index, scope.row)"></el-button>
                  <el-button
                    circle
                    icon="el-icon-s-custom"
                    plain
                    size="mini"
                    title="分配角色"
                    @click="disRoles(scope.$index, scope.row)"></el-button>
                  <el-button
                    circle
                    icon="el-icon-edit"
                    plain
                    size="mini"
                    title="编辑"
                    type="primary"
                    @click="formEdit(scope.$index, scope.row)"></el-button>
                  <el-button
                    circle
                    icon="el-icon-delete"
                    plain
                    size="mini"
                    title="删除"
                    type="danger"
                    @click="formDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div class="pagination">-->
            <!--   <el-pagination-->
            <!--     :current-page="currentPage"-->
            <!--     :page-size="rows"-->
            <!--     :page-sizes="[15, 30, 50, 100]"-->
            <!--     :total="total"-->
            <!--     layout="total, sizes, prev, pager, next, jumper"-->
            <!--     @size-change="handleSizeChange"-->
            <!--     @current-change="handleCurrentChange">-->
            <!--   </el-pagination>-->
            <!-- </div>-->
          </div>
        </div>
      </template>
    </split-pane>
    <el-dialog title="移动" :visible.sync="dialogVisible" width="50%">
      <div class="el-dialog-div">
        <el-tree highlight-current ref="tree" node-key="id" :default-expanded-keys="defaultExpandedKeys" :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="moveConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" title="资源信息" width="80%">
      <el-tabs v-model="activeTab" class="dialogTabStyle" @tab-click="tabChange()">
        <el-tab-pane label="pc端" name="11"></el-tab-pane>
        <el-tab-pane label="移动端" name="1011"></el-tab-pane>
      </el-tabs>
      <el-form v-if="dialogFormVisible" ref="resourceForm" :model="resourceForm" :rules="rules">
        <!-- 当为pc端时 -->
        <div v-if="activeTab=='11'">
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="名称" prop="resourceName">
                <el-input v-model="resourceForm.resourceName" placeholder="资源名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="地址">
                <el-input v-model="resourceForm.url" placeholder="资源地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="编码">
                <el-input v-model="resourceForm.key" placeholder="编码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="组件配置">
                <el-input v-model="resourceForm.widgetJson" placeholder="组件配置"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="排序号" prop="orderNo">
                <el-input v-model="resourceForm.orderNo" placeholder="排序号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="打开方式">
                <el-input v-model="resourceForm.target" placeholder="打开方式"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="类型" prop="type">
                <el-radio-group v-model="resourceForm.type">
                    <el-radio label="system">系统</el-radio>
                  <el-radio label="menu">菜单</el-radio>
                  <el-radio label="button">按钮</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="资源值">
                <el-input v-model="resourceForm.value" placeholder="资源值"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="关联类型" prop="linkType">
                <el-select v-model="resourceForm.linkType" clearable placeholder="请选择关联类型" style="width: 100%;"
                           @change="linkTypeChange">
                  <el-option v-for="item in menuLinkType" :key="item.id" :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="合同段层次" prop="proType">
                <el-select v-model="resourceForm.proType" clearable multiple placeholder="请选择合同段层次"
                           style="width: 100%;" @change="proTypeChange">
                  <el-option v-for="item in projectOrgType" :key="item.value" :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="是否收回菜单" prop="isShrinkMenu">
                <el-switch v-model="resourceForm.isShrinkMenu" active-value="1" inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="'160px'" label="启用角色单位数据权限" prop="roleOrgFilter">
                <el-switch v-model="resourceForm.roleOrgFilter" active-value="1" inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="12">
                <el-form-item label="客户端平台" :label-width="formLabelWidth" prop="platform">
                <el-radio-group v-model="resourceForm.platform">
                    <el-radio label="11">PC端</el-radio>
                    <el-radio label="1011">移动端</el-radio>
                </el-radio-group>
                </el-form-item>
            </el-col> -->

          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="默认图标">
                <el-input v-model="resourceForm.icon" placeholder="默认图标:如果取自案例图标库请输入font_family，例如：font_family icon-bq2"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="选中图标">
                <el-input v-model="resourceForm.iconSelected" placeholder="选中图标:如果取自案例图标库请输入font_family，例如：font_family icon-bq2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="资源图标" prop="roleOrgFilter">
                <el-upload
                  :before-upload="beforeAvatarUpload"
                  :data="{'metaData.formId':resourceForm.resourceId,'metaData.fileName': '资源图标','metaData.fileType': 'loginSourceUrl'}"
                  :file-list="sourceList"
                  :limit="1"
                  :multiple="false"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess"
                  action="/api/zuul/fs/files/upload"
                  class="upload-demo"
                  list-type="picture">
                  <el-button icon="el-icon-plus" size="small" style="margin:10px 0px 10px 10px;" type="primary">选择文件
                  </el-button>
                  <!-- <div slot="tip" class="el-upload__tip">上传后必须保存！否则不生效！</div> -->
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="选中图标" prop="roleOrgFilter">
                <el-upload
                  :before-upload="beforeAvatarUpload"
                  :data="{'metaData.formId':resourceForm.resourceId,'metaData.fileName': '选中图标','metaData.fileType': 'loginSourceUrlPro'}"
                  :file-list="sourceList2"
                  :limit="1"
                  :multiple="false"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  action="/api/zuul/fs/files/upload"
                  class="upload-demo"
                  list-type="picture">
                  <el-button icon="el-icon-plus" size="small" style="margin:10px 0px 10px 10px;" type="primary">选择文件
                  </el-button>
                  <!-- <div slot="tip" class="el-upload__tip">上传后必须保存！否则不生效！</div> -->
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label-width="'120px'" label="描述" prop="description">
                <el-input v-model="resourceForm.description" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 当为app端时 -->
        <div v-if="activeTab=='1011'">
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="名称" prop="resourceName">
                <el-input v-model="resourceForm.resourceName" placeholder="资源名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="地址">
                <el-input v-model="resourceForm.url" placeholder="资源地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="编码">
                <el-input v-model="resourceForm.key" placeholder="编码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="排序号" prop="orderNo">
                <el-input v-model="resourceForm.orderNo" placeholder="排序号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="图标名称" prop="icon">
                <el-input v-model="resourceForm.icon" placeholder="图标名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="'120px'" label="图标样式" prop="iconStyle">
                <el-input v-model="resourceForm.iconStyle" placeholder="图标样式"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>

            <!-- <el-col :span="12">
                <el-form-item label="类型" :label-width="formLabelWidth" prop="type">
                <el-radio-group v-model="resourceForm.type">
                    <el-radio label="menu">菜单</el-radio>
                    <el-radio label="button">按钮</el-radio>
                </el-radio-group>
                </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="资源值">
                <el-input v-model="resourceForm.value" placeholder="资源值"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="动作类型" prop="actionType">
                <el-select v-model="resourceForm.actionType" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in actionOptData" :key="item.code" :label="item.name"
                             :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="关联类型" prop="linkType">
                <el-select v-model="resourceForm.linkType" clearable placeholder="请选择关联类型" style="width: 100%;"
                           @change="linkTypeChange">
                  <el-option v-for="item in menuLinkType" :key="item.id" :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="合同段层次" prop="proType">
                <el-select v-model="resourceForm.proType" clearable multiple placeholder="请选择合同段层次"
                           style="width: 100%;" @change="proTypeChange">
                  <el-option v-for="item in projectOrgType" :key="item.value" :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="12">
                  <el-form-item label="页面属性" :label-width="formLabelWidth">
                  <el-input v-model="resourceForm.typeStr" placeholder="页面属性"></el-input>
                  </el-form-item>
              </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label-width="formLabelWidth" label="所属平台">
                <!-- <el-input v-model="resourceForm.mobileType" placeholder="页面类型"></el-input> -->
                <el-select v-model="resourceForm.mobileType" placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="item in mobileTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
                <el-form-item label="android视图名 " :label-width="formLabelWidth">
                <el-input v-model="resourceForm.androidClassName" placeholder="android视图名 "></el-input>
                </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item :label-width="'160px'" label="启用角色单位数据权限" prop="roleOrgFilter">
                <el-switch v-model="resourceForm.roleOrgFilter" active-value="1" inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="24">
                <el-form-item label="描述" :label-width="'120px'" prop="description">
                <el-input type="textarea" v-model="resourceForm.description"></el-input>
                </el-form-item>
            </el-col> -->
          </el-row>
          <div class="typeMain">
            <div class="typeMain-item">
              <!-- IOS -->
              <div class="typeMain-title">IOS</div>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label-width="formLabelWidth" label="IOS视图名">
                    <el-input v-model="resourceForm.iosClassName" placeholder="IOS视图名"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label-width="formLabelWidth" label="故事板ID">
                    <el-input v-model="resourceForm.sbId" placeholder="故事板ID"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label-width="formLabelWidth" label="故事板名称">
                    <el-input v-model="resourceForm.sbName" placeholder="故事板名称"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </div>
            <div class="typeMain-item">
              <!-- android -->
              <div class="typeMain-title">android</div>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label-width="formLabelWidth" label="android视图名 ">
                    <el-input v-model="resourceForm.androidClassName" placeholder="android视图名 "></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label-width="formLabelWidth" label="应用路径">
                    <el-input v-model="resourceForm.androidPackage" placeholder="应用路径"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label-width="formLabelWidth" label="协议">
                    <el-input v-model="resourceForm.androidProtocol" placeholder="协议"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <el-row>
            <div style="margin-bottom: 10px;">扩展属性
              <i class="el-icon-circle-plus-outline" style="font-size: 19px; color: #81acf1; position: relative;  top: 2px;"
                 @click="addDomain"></i>
              <!-- <el-button style="margin-left:5px" size="small" type="primary" @click="addDomain">新增</el-button> -->
            </div>
            <el-form v-for="(domain, index) in elementExts" :key="domain.key" ref="elementExts" label-width="62px"
                     size="small">
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    :key="index"
                    :label="'键'"
                    :label-width="formLabelWidth"
                  >
                    <el-input v-model="domain.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :key="index"
                    :label="'值'"
                    :label-width="formLabelWidth"
                  >
                    <el-input v-model="domain.value" style="width:70%"></el-input>
                    <i class="el-icon-delete" style="margin-left:5px;color:red"
                       @click.prevent="removeDomain(domain)"></i>
                    <!-- <el-button type="danger" style="margin-left:5px" @click.prevent="removeDomain(domain)">删除</el-button> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formSave('resourceForm')">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog id="rolesDialog" :close-on-click-modal="false" :visible.sync="dialogRolesVisible" title="分配角色">
      <div style="display: flex;height: 380px">
        <div style="width: calc(50% - 20px);">
          <div style="margin-left: 10px">待选角色</div>
          <RolesTree :key="infoLeft" :parentMsg="rolesTreeMsg" v-on:getCheckedKeys="getRolesKeys"></RolesTree>
        </div>
        <div style="border-right: 1px solid #d9d9d9;margin: 0 20px"></div>
        <div style="width: calc(50% - 20px);">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <div style="margin-left: 10px">已选角色</div>
            <div @click="open" style="margin-right: 10px;cursor: pointer;color: #409EFF">重新选择</div>
          </div>
          <RolesTree :key="infoRight" :filter="true" :parentMsg="rolesTreeMsg" v-on:getCheckedKeys="getRolesKeys"></RolesTree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
<!--        <el-button type="primary" @click="dialogRolesVisible = false">确 定</el-button>-->
        <el-button @click="dialogRolesVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ResourcesTree from '../components/ResourcesTree.vue'
import RolesTree from '../components/RolesTree.vue'
import Sortable from "sortablejs"

export default {
  name: 'resourceManage',
  components: {
    ResourcesTree,
    RolesTree
  },

  data() {
    var checkNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('排序号不能为空且大于0'))
      }
      setTimeout(() => {
        if (!Number.isInteger(parseInt(value))) {
          callback(new Error('排序号为数值'))
        } else {
          callback()
        }
      }, 100)
    }
    return {
      treeMsg: {
        title: '资源管理', // 标题
        refreshTreeFlag: false, // 刷新标志
        self: 1, // 是（1）否（0）包含自身
        async: 0, // 同步树（0）异步树（1）
        showCheckBox: false, // 是否显示多选框
        onlyLeaf: true, // 是否只需要叶子节点(有多选框时使用)
        defaultCheckedKeys: [] // 默认选中
      },
      handleNodeData:'',
      moveRowData:'',
      defaultExpandedKeys: [],
      treeData:[],
      defaultProps: {
        children: 'children',
        label: 'label',
        disabled: 'disabled',
      },
      dialogVisible: false,
      projectOrgType: [],
      menuLinkType: [],
      resourcesTreeMsg: {},
      rolesTreeMsg: {},
      treeInfo: [],
      tableData: [],
      dialogFormVisible: false,
      dialogRolesVisible: false,
      resourceForm: {},
      formLabelWidth: '120px',
      total: 0,
      rows: 1000,
      currentPage: 1,
      selectResourceId: '',
      rules: {
        resourceName: [
          {required: true, message: '请输入名称', trigger: 'blur'},
          {min: 1, max: 20, message: '长度在 1 到 20 个字符之间', trigger: 'blur'}
        ],
        orderNo: [
          {validator: checkNum, trigger: 'blur'}
        ]
      },
      sourceList: [],
      sourceList2: [],
      breadList: [],
      activeTab: '11',
      actionOptData: [],
      elementExts: [],
      mobileTypeOptions: [{label: '全部', value: 'all'}, {label: 'ios', value: 'ios'}, {
        label: 'android',
        value: 'android'
      }],
      disRolesIndex:'',
      disRolesRow:'',
      infoRight:'',
      infoLeft:'',
    }
  },
  mounted: function () {
    // 调用 table拖拽排序
    this.rowDrop()
    //枚举
    this.getProjectOrg();
    //枚举
    this.getMenuLinkType();
    //获取枚举动作类型
    this.getActionOpt()
    this.resourcesTreeMsg = {
      title: '资源管理',
      refreshTreeFlag: false,
      self: 1,
      async: 0,
      showCheckBox: false,
      onlyLeaf: false,
      copyResourceForm: {}
    }
  },
  methods: {
    // 行拖拽
    rowDrop () {
      let tbody = document.querySelector('.el-table__body-wrapper tbody')
      let _this = this
      Sortable.create(tbody, {
        // or { name: "...", pull: [true, false, 'clone', array], put: [true, false, array] }
        group: {
          name: 'words',
          pull: true,
          put: true
        },
        animation: 150, // ms, number 单位：ms，定义排序动画的时间
        onAdd: function (evt) { // 拖拽时候添加有新的节点的时候发生该事件
          console.log('onAdd.foo:', [evt.item, evt.from])
        },
        onUpdate: function (evt) { // 拖拽更新节点位置发生该事件
          console.log('onUpdate.foo:', [evt.item, evt.from])
        },
        onRemove: function (evt) { // 删除拖拽节点的时候促发该事件
          console.log('onRemove.foo:', [evt.item, evt.from])
        },
        onStart: function (evt) { // 开始拖拽出发该函数
          console.log('onStart.foo:', [evt.item, evt.from])
        },
        onSort: function (evt) { // 发生排序发生该事件
          console.log('onUpdate.foo:', [evt.item, evt.from])
        },
        // 结束拖拽
        onEnd: function ({ newIndex, oldIndex }) { // 结束拖拽
          let currRow = _this.tableData.splice(oldIndex, 1)[0]
          _this.tableData.splice(newIndex, 0, currRow)
          let data = JSON.parse(JSON.stringify(_this.tableData))
          let arr = []
          let str = ''
          data.forEach((item,index) => {
            arr.push(item.resourceId)
          })
          str = arr.join(',')
          _this.reorder(str)
          console.log(str,999);
        }
      })
    },
    reorder(str) {
      this.$axios.post(`/api/resource/updateResourceOrder?resourceId=${str}`).then(res => {
        if (res.data.succeed) {
          this.getList()
        }
      }).catch(error => {
        console.log('error:' + error.toString())
      })
    },
    removeDomain(item) {
      let index = this.elementExts.indexOf(item)
      if (index !== -1) {
        this.elementExts.splice(index, 1)
      }
    },
    addDomain() {
      this.elementExts.push({
        name: '',
        value: '',
      });
    },
    tabChange() {
      //   this.resourceForm.platform=this.activeTab
      console.log("判断", this.activeTab, this.copyResourceForm.platform)
      if (this.activeTab != this.copyResourceForm.platform) {
        this.resourceForm = {
          type: "menu",
          mobileType: "all",
          resourceId: '',
          resourceName: '',
          parentId: '',
          key: '',
          widgetJson: '',
          url: '',
          orderNo: 1
        };
      } else {
        this.resourceForm = JSON.parse(JSON.stringify(this.copyResourceForm))

      }

    },
    //获取枚举动作类型
    getActionOpt() {
      this.$axios.get('/api/category/getCategoryList/key?value=idm_resource_action_type').then(
        response => {
          if (response.data.succeed) {
            console.log("mei", response)
            this.actionOptData = response.data.data
          } else {
            console.log('error:' + response.data.msg)
          }
        })
        .catch(error => {
          console.log('error:' + error.toString())
        })
    },
    //点击图片
    handlePreview(file) {
      window.open("/api/fs/files/download/" + file.id);
    },
    //删除选择文件
    handleRemove(file, fileList) {
      if (!file.metaData) {
        this.resourceForm.attaId = "";
        return;
      }
      if (file.metaData.fileType == "homeLogoUrl") {
        this.resourceForm.homeLogoUrl = "";
      } else if (file.metaData.fileType == "sloganUrl") {
        this.resourceForm.sloganUrl = "";
      } else if (file.metaData.fileType == "loginLogoUrl") {
        this.resourceForm.loginLogoUrl = "";
      }
      this.$axios.delete('/api/fs/files/delete/' + file.id).then(res => {
        this.getFilesData(file.metaData.formId, file.metaData.fileType);
      }).catch(error => {
        console.log('error:' + error.toString())
      })
    },
    beforeAvatarUpload(file) {
      let fileName = file.name.toLowerCase();
      const isExcel = (fileName.indexOf(".png") != -1 || fileName.indexOf(".jpeg") != -1 || fileName.indexOf(".jpg") != -1);
      if (!isExcel) {
        this.$message.error('图标只能是 图片!');
      }
      return isExcel;
    },
    //change事件  互斥
    linkTypeChange(value) {
      if (value != "" && value != null && value != undefined) {
        this.resourceForm.proType = "";
      }
      // console.log("linkType",value);
    },
    //change事件  互斥
    proTypeChange(value) {
      if (value != "" && value != null && value != undefined) {
        this.resourceForm.linkType = "";
      }
      // console.log("proType",JSON.stringify(value));
    },
    //枚举
    getProjectOrg() {
      this.$axios.get('/api/proOrg/getSectionMajor').then(
        response => {
          if (response.data.succeed) {
            this.projectOrgType = response.data.data
          } else {
            console.log('error:' + response.data.msg)
          }
        })
        .catch(error => {
          console.log('error:' + error.toString())
        })
    },
    //枚举
    getMenuLinkType() {
      this.$axios.get('/api/category/getCategoryList/key?value=menuLinkType').then(
        response => {
          if (response.data.succeed) {
            this.menuLinkType = response.data.data
          } else {
            console.log('error:' + response.data.msg)
          }
        })
        .catch(error => {
          console.log('error:' + error.toString())
        })
    },
    handleSizeChange(val) {
      this.rows = val
      this.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    getTreeInfo: function (data, breadList) {
      console.log("节点参数", data)
      this.currentPage = 1;
      this.treeInfo = data
      this.breadList = breadList
      this.getList()
    },
    getPageMsg: function (data) {
      this.pageMsg.currentPage = data
      this.getList()
    },
    getisDefault: function (data) {
      if (data == 1) {
        return '是'
      } else {
        return '否'
      }
    },
    getList: function () {
      this.$axios.get(
        this.$idmConfig.resources.ListUrl + '?t=' + new Date().getTime(),
        {
          params: {
            parentId: this.treeInfo.listenParentId,
            page: this.currentPage,
            rows: this.rows
          }
        }
      ).then(data => {
        if (data.status === 200) {
          data.data.rows.map((item) => {
            if (item.proType) {
              item.proType = item.proType.replace(/\[/g, "");
              item.proType = item.proType.replace(/\]/g, "");
              item.proType = item.proType.replace(/\"/g, "");
              item.proType = item.proType ? item.proType.split(",") : "";
            }
          })
          this.tableData = data.data.rows
          this.total = data.data.total
          console.log(this.treeInfo, 411);
          console.log(this.tableData, 411);
        } else {
          this.$message({
            message: data.statusText,
            showClose: true,
            type: 'error'
          })
        }
      })
    },
    formAdd() {
      this.elementExts = []
      this.activeTab = this.treeInfo.platform || '11'
      this.copyResourceForm = {}
      if (this.$refs.resourceForm) {
        this.$refs.resourceForm.clearValidate()
      }
      this.sourceList = []
      this.sourceList2 = []
      this.resourceForm = {
        type: "menu",
        mobileType: 'all',
        resourceId: '',
        resourceName: '',
        parentId: '',
        key: '',
        widgetJson: '',
        url: '',
        orderNo: 1
      };
      this.dialogFormVisible = true
      this.platform()
    },
    // 判断客户端类型是否可选
    platform() {
      console.log(this.breadList);
      if (!!this.breadList && this.breadList.length > 1) {
        this.resourceForm.platform = this.breadList[this.breadList.length - 2].otherInfo.platform
      } else {
        this.resourceForm.platform = '11'
      }
    },
    formSave(resourceForm) { // 保存节点
      this.$refs[resourceForm].validate((valid) => {
        if (valid) {
          // 处理扩展属性键值对
          let descObj = {}
          if (this.elementExts.length > 0) {
            this.elementExts.forEach(i => {
              this.$set(descObj, i.name, i.value)
            })
          }

          console.log("对象", descObj)
          if(this.activeTab=='1011'){
             this.resourceForm.description = JSON.stringify(descObj)
          }
        //   this.resourceForm.description = JSON.stringify(descObj)
          this.resourceForm.platform = this.activeTab
          this.resourceForm.parentId = this.treeInfo.listenParentId
          var params = this.resourceForm;
          let strProType = "";
          for (let index in params.proType) {
            strProType += params.proType[index] + ",";
          }
          if (strProType.length > 0) {
            strProType = strProType.substring(0, strProType.length - 1);
          }
          params.proType = strProType;
          //params.proType 空对象赋值为空
          // if(!params.proType || params.proType==[] || params.proType=="[]" || params.proType.length==0){
          //   params.proType = "";
          // }else{
          //   params.proType = JSON.stringify(params.proType);
          // }
          var url = this.$idmConfig.resources.addUrl
          if (params.resourceId !== null && params.resourceId !== '') {
            url = this.$idmConfig.resources.editUrl
          }
          this.$axios.post(
            url,
            this.$qs.stringify(params)
          ).then(data => {
            if (data.data.succeed) {
              this.dialogFormVisible = false
              this.getList(this.treeInfo.listenParentId)
              if (params.resourceId !== null && params.resourceId !== '') {
                this.resourcesTreeMsg = {
                  title: '资源管理',
                  refreshTreeFlag: true,
                  self: 1,
                  async: 0,
                  showCheckBox: false,
                  onlyLeaf: false
                }
              } else {
                this.resourcesTreeMsg = {
                  title: '资源管理',
                  refreshTreeFlag: true,
                  self: 1,
                  async: 0,
                  showCheckBox: false,
                  onlyLeaf: false
                }
              }
            } else {
              this.$message({
                message: data.data.msg,
                showClose: true,
                type: 'error'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    formEdit(index, row) {
      this.elementExts = []
      console.log("点击formEdit", row)
      this.getLoginResourceIconData(row.resourceId)
      this.sourceList = []
      this.sourceList2 = []
      if (this.$refs.resourceForm) {
        this.$refs.resourceForm.clearValidate()
      }
      if (row.platform=='1011'&&!!row.description) {
        let descObj = JSON.parse(row.description)
        for (let i in descObj) {
          let obj = {}
          obj.name = i
          obj.value = descObj[i]
          this.elementExts.push(obj)
        }

      }
      //   this.elementExts.forEach(i=>{
      //             this.$set(descObj,i.name,i.value)
      //         })
      this.resourceForm = row;
      this.activeTab = this.resourceForm.platform
      this.copyResourceForm = JSON.parse(JSON.stringify(row))
      // console.log(this.resourceForm);
      this.dialogFormVisible = true
    },
    getLoginResourceIconData(formId) {
      this.sourceList = []
      this.sourceList2 = []
      let params = {
        'metaData.formId': formId,
        // 'metaData.fileType': 'loginSourceUrl'
      }
      this.$axios.post('/api/fs/files/search', this.$qs.stringify(params)).then(res => {
        if (res.data && res.data.length > 0) {
          res.data.map((item, index) => {
            item.name = item.metaData.fileName;
            item.url = "/api/fs/files/download/" + item.id;
            if(item.metaData.fileType=="loginSourceUrl")
            {
              this.sourceList.push(item)
            }else{
              this.sourceList2.push(item)
            }
          })
        }
      }).catch(error => {
        console.log('error:' + error.toString())
      })
    },
    formDelete(index, row) {
      this.$confirm('永久删除该资源及子孙资源, 是否继续?', '提示', {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(
          this.$idmConfig.resources.deleteUrl,
          this.$qs.stringify({resourceId: row.resourceId})
        ).then(data => {
          if (data.data.succeed) {
            this.getList(this.treeInfo.listenParentId)
            this.resourcesTreeMsg = {
              title: '资源管理',
              refreshTreeFlag: true,
              self: 1,
              async: 0,
              showCheckBox: false,
              onlyLeaf: false
            }
          } else {
            this.$message({
              message: data.data.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          showClose: true,
          message: '已取消删除'
        })
      })
    },
    // 为资源分配角色
    disRoles: function (index, row,filter) {
      this.disRolesIndex = index;
      this.disRolesRow = row;
      this.selectResourceId = row.resourceId
      this.$axios.post(
        this.$idmConfig.resources.resourceAlreadyToRolesUrl,
        this.$qs.stringify({
          resourceId: this.selectResourceId
        })
      ).then(result => {
        if (result.data.succeed) {
          var selectedArr = []
          for (var i = 0; i < result.data.data.length; i++) {
            selectedArr.push(result.data.data[i].ROLE_ID)
          }
          this.rolesTreeMsg = {
            title: '角色管理',
            refreshTreeFlag: false,
            self: 1,
            async: 0,
            showCheckBox: true,
            onlyLeaf: false,
            defaultCheckedKeys: selectedArr
          }
          this.dialogRolesVisible = true
          if (!!filter) {
            this.infoLeft = new Date().getTime()
          } else  {
            this.infoRight = new Date().getTime()
          }
        } else {
          this.$message({
            message: result.data.msg,
            showClose: true,
            type: 'error'
          })
        }
      })
    },
    // 移动
    move(index, row) {
      this.getTemplateTree()
      this.moveRowData = row
      this.dialogVisible = true;
    },
    // moveConfirm
    moveConfirm() {
      this.$axios.post(`/api/resource/moveResource?parentId=${this.handleNodeData.id}&resourceId=${this.moveRowData.resourceId}`).then(res => {
        if (res.data.succeed) {
          this.getList()
          this.$refs.resourcesTree.getTemplateTree()
          this.dialogVisible = false;
          this.$message({
            message: '移动成功',
            type: 'success'
          });
        }
      }).catch(error => {
        this.$message({
          message: '移动失败',
          type: 'success'
        });
      })
    },
    // 点击节点
    handleNodeClick(node) {
      this.handleNodeData = node
      console.log(node);
    },
    getTemplateTree (data) {
      this.loading=true;
      this.$axios.get(
        this.$idmConfig.resources.TreeUrl
        + '?resourceId=' + this.$idmConfig.resources.parentId
        + '&self=' + this.treeMsg.self + '&async='
        + this.treeMsg.async+'&t=' + new Date().getTime()
      ).then(response => {
        this.loading=false;
        if (response.data.length <= 0) {
          this.$emit('treeInfo', { 'listenParentId': '-10', 'listenParentName': '暂无' })
        } else {
          // 展开至第一级
          this.defaultExpandedKeys = [response.data[0].id];
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(response.data[0].id)
          })
          this.handleNodeData = response.data[0]
          console.log(this.handleNodeData,666);
          //顶级菜单不可选中 disabled
          // if(response.data[0].id=='-1'){
          //   response.data[0].disabled=true;
          // }
          // if (response.data[0].children !== null && response.data[0].children.length > 0) {
          //   // 展开至第二级
          //   for (var i = 0; i < response.data[0].children.length; i++) {
          //     this.defaultExpandedKeys.push(response.data[0].children[i].id)
          //   }
          // }
          this.treeData = response.data
          if (!data.refreshTreeFlag) {
            this.$emit('treeInfo', { 'listenParentId': response.data[0].id, 'listenParentName': response.data[0].label })
          }
        }
      }).catch(error => {
        this.loading=false;
        console.log('error:' + error.toString())
      })
    },
    open() {
      this.$confirm('此操作将清空已选角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getRolesKeys([])
        this.$message({
          type: 'success',
          message: '清空成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清空'
        });
      });
    },
    getRolesKeys: function (data,filter) {
      this.$axios.post(
        this.$idmConfig.resources.resourceToRolesUrl,
        this.$qs.stringify({
          resourceId: this.selectResourceId,
          jsonRoleIds: JSON.stringify(data)
        })
      ).then(data => {
        if (data.data.succeed) {
          var a = ''
          this.disRoles(this.disRolesIndex,this.disRolesRow,filter)
        } else {
          this.$message({
            message: data.data.msg,
            showClose: true,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/ .splitter-pane-resizer.vertical[data-v-212fa2a4] {
  background-color: #e6eef8;
  width: 14px;
}

/deep/ .splitter-pane-resizer[data-v-212fa2a4] {
  opacity: initial;
}

#main {
  height: 100%;
}

#treeDivs {
  width: 100%;
  height: 100%;
  float: left;
  background: white;
  margin-right: 5px;
  /* overflow: auto; */
}

#listTables {
  width: 100%;
  float: right;
  background: white;
  height: 100%;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.pagination {
  height: 32px;
  margin: 0px 0 -32px;
  background: #ECF5FF;
  text-align: left;
}

.rightTopButton {
  text-align: left;
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.rightContent {
  height: calc(100vh - 60px);
  background: white;
  overflow: auto;
  padding: 0 10px 32px;
  box-sizing: border-box;
}
.el-dialog-div {
  height: 400px;
  overflow: auto;
}
</style>
<style>
#rolesDialog .el-tree {
  max-height: 350px;
  overflow-y: auto;
}
</style>
<style lang="less" scoped>
.dialogTabStyle {
  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }
}

.typeMain {
  display: flex;
  width: 100%;

  .typeMain-item {
    width: 50%;
  }

  .typeMain-title {
    font-size: 16px;
    font-weight: 600;
    margin-left: 50px;
    border-bottom: 1px solid #7fbfef;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Resources.vue